<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <!-- HERO -->
  <section class="hero">
    <div class="hero-bg" style="background-image: url('assets/activity/hero-bg.jpg')"></div>
    <div class="hero-text">
      <h1>Activity</h1>
      <p>Track your progress. See your impact. Watch your community grow.</p>
    </div>
    <div class="hero-quote">“Your Activity<br />Creates<br /><span>Opportunity.</span>”</div>
  </section>

  <!-- STATS -->
  <section class="stats">
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-eye"></i></div>
      <div><span>Total Views</span><b>{{ totalViews }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-share-nodes"></i></div>
      <div><span>Total Shares</span><b>{{ totalShares }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-user-group"></i></div>
      <div><span>New Connections</span><b>{{ connections }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-handshake"></i></div>
      <div><span>Referral Sign Ups</span><b>{{ referrals }}</b></div>
    </div>
  </section>

  <section class="main">

    <!-- LEFT -->
    <div class="col">
      <div class="panel">
        <div class="p-head">
          <h3>Activity Overview</h3>
          <select class="sel" [(ngModel)]="range" (ngModelChange)="onRange()">
            <option *ngFor="let r of ranges" [ngValue]="r">Last {{ r }} Days</option>
          </select>
        </div>

        <svg viewBox="0 0 700 260" class="chart">
          <defs>
            <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="#ff0f7b" stop-opacity=".55" />
              <stop offset="100%" stop-color="#ff0f7b" stop-opacity="0" />
            </linearGradient>
          </defs>
          <g *ngFor="let t of yTicks">
            <line [attr.x1]="t.x1" [attr.x2]="t.x2" [attr.y1]="t.y" [attr.y2]="t.y" stroke="#2a2a33" stroke-width="1" />
            <text [attr.x]="t.x1 - 8" [attr.y]="t.y + 4" text-anchor="end" fill="#ddd" font-size="12">{{ t.v }}</text>
          </g>
          <path [attr.d]="area" fill="url(#areaGrad)" />
          <polyline [attr.points]="line" fill="none" stroke="#ff2d9b" stroke-width="2.5" stroke-linejoin="round" />
          <circle *ngFor="let p of dots" [attr.cx]="p.x" [attr.cy]="p.y" r="3.5" fill="#ff0f7b" />
          <text *ngFor="let l of xLabels" [attr.x]="l.x" [attr.y]="l.y" text-anchor="middle" fill="#ddd" font-size="12">{{ l.t }}</text>
        </svg>
      </div>

      <div class="two">
        <div class="panel">
          <div class="p-head"><h3>Activity Breakdown</h3></div>
          <div class="donut-wrap">
            <div class="donut">
              <svg viewBox="0 0 180 180">
                <g transform="rotate(-90 90 90)">
                  <circle cx="90" cy="90" r="70" fill="none" stroke="#23232b" stroke-width="22" />
                  <circle *ngFor="let s of segments" cx="90" cy="90" r="70" fill="none" [attr.stroke]="s.color"
                          stroke-width="22" [attr.stroke-dasharray]="s.dash" [attr.stroke-dashoffset]="s.off" />
                </g>
              </svg>
              <div class="donut-c"><b>{{ total }}</b><span>Total Activity</span></div>
            </div>
            <ul class="legend">
              <li *ngFor="let s of segments">
                <i class="dot" [style.background]="s.color"></i>
                <span class="lb">{{ s.label }}</span>
                <b>{{ s.n }}</b>
                <em>{{ s.pct }}%</em>
              </li>
            </ul>
          </div>
        </div>

        <div class="panel">
          <div class="p-head"><h3>Top Cards</h3><a routerLink="/cards" class="va">View All <i class="fa-solid fa-arrow-right"></i></a></div>
          <ul class="top">
            <li *ngFor="let c of topCards; let i = index" [routerLink]="['/cards/preview-card', c.id]">
              <span class="rank">{{ i + 1 }}</span>
              <span class="thumb" [style.backgroundImage]="'url(' + (c.change_photo || 'assets/images/avatar.png') + ')'"></span>
              <div class="t-txt"><b>{{ cardName(c) }}</b><small>{{ c.totalViews || 0 }} views</small></div>
              <i class="fa-solid fa-chevron-right"></i>
            </li>
            <li class="none" *ngIf="topCards.length === 0">No cards yet.</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="col">
      <div class="panel">
        <div class="p-head">
          <h3>Recent Activity</h3>
          <a class="va" (click)="showAll = !showAll">{{ showAll ? 'Show Less' : 'View All' }} <i class="fa-solid fa-arrow-right"></i></a>
        </div>

        <ul class="recent">
          <li *ngFor="let a of recent">
            <span class="r-ico"><i [class]="iconOf(a)"></i></span>
            <div class="r-txt"><b>{{ a.activity }}</b><small>{{ ago(a) }}</small></div>
            <span class="r-tag" *ngIf="tagOf(a)">{{ tagOf(a) }}</span>
            <button type="button" class="del" [disabled]="deletingId === a.id" (click)="deleteActivity(a)" title="Delete">
              <i class="fa-solid fa-trash-can"></i>
            </button>
          </li>
        </ul>

        <div class="empty" *ngIf="list.length === 0">
          <div class="empty-ico"><i class="fa-solid fa-bolt"></i></div>
          <h4>No activity found</h4>
          <p>Your cards, requests and live sessions will show up here.</p>
        </div>
      </div>

      <div class="panel">
        <div class="p-head"><h3>Filters</h3><a class="va" (click)="resetFilters()">Reset</a></div>
        <div class="f-row"><i class="fa-regular fa-calendar"></i>
          <select [(ngModel)]="dRange">
            <option *ngFor="let r of ranges" [ngValue]="r">Last {{ r }} Days</option>
          </select>
        </div>
        <div class="f-row"><i class="fa-solid fa-list"></i>
          <select [(ngModel)]="dType">
            <option value="all">All Activity Types</option>
            <option *ngFor="let t of types" [value]="t.key">{{ t.label }}</option>
          </select>
        </div>
        <button type="button" class="b-pink" (click)="applyFilters()">Apply Filters</button>
      </div>
    </div>
  </section>
</main>